










































import { Vue, Component, Prop } from "vue-property-decorator";
import CatalogueSettingSelect from "@/components/CatalogueSettings/Select.vue";
import { catalogueSettings } from "@/models/Setting";
import { firstLowerCase, camelToUnderscore } from "../../utils/Typography";

@Component({
  components: {
    CatalogueSettingSelect,
  },
})
export default class Filters extends Vue {
  private filter = {};
  get selects() {
    return catalogueSettings.filter((o) => o.type !== "catalogueCapacities");
  }

  mounted() {
    this.filter = { ...this.$route.query };
    this.apply();
  }

  apply() {
    this.$emit("apply", { filter: this.filter });
  }

  queryKey(setting) {
    return setting.singularType.toLowerCase().replace("catalogue", "");
  }

  reset() {
    this.$emit("reset");

    let query = { ...this.$route.query };
    for (const key in query) {
      delete query[key];
    }
    this.$router.push({ query: { ...query } }).catch(() => {});
    this.filter = {};
  }

  onCatalogueSettingChanged(rawKey, value) {
    let key = firstLowerCase(rawKey.replace("catalogue", ""));
    key = camelToUnderscore(key);
    if (!value || value === "all") {
      delete this.filter[key];
    } else {
      this.filter[key] = value;
    }
  }
}
